import { distributionPlans } from "../../../mocks/magazine";
import { Link } from "react-router-dom";

export default function DistributionOptions() {
  return (
    <section className="bg-[#F8F4EE] py-24 md:py-32">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        {/* Header */}
        <div className="text-center mb-14">
          <p className="text-[#C41E3A] text-xs tracking-[0.3em] uppercase font-semibold mb-4">Distribution Plans</p>
          <h2 className="text-4xl md:text-5xl font-serif font-light text-[#1C1C1C] leading-tight">
            Your Schedule,<br />Your Magazine
          </h2>
          <p className="text-[#5A5A5A] mt-5 text-lg font-light max-w-xl mx-auto">
            Publish at a cadence that matches how you create — not the other way around.
          </p>
        </div>

        {/* Plans */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          {distributionPlans.map((plan) => (
            <div
              key={plan.id}
              className={`rounded-2xl p-8 flex flex-col gap-5 transition-transform duration-300 hover:-translate-y-1 ${
                plan.highlight
                  ? "bg-[#C41E3A] text-white"
                  : "bg-white border border-[#E8E2DA] text-[#1C1C1C]"
              }`}
            >
              {plan.highlight && (
                <span className="self-start px-3 py-1 rounded-full bg-white/20 text-white text-xs font-semibold tracking-wide">
                  Most Popular
                </span>
              )}
              <div className={`w-12 h-12 flex items-center justify-center rounded-full ${plan.highlight ? "bg-white/20" : "bg-[#F5F1E8]"}`}>
                <span className={`text-xl flex items-center justify-center w-6 h-6 ${plan.highlight ? "text-white" : "text-[#C41E3A]"}`}>
                  <i className={plan.icon} />
                </span>
              </div>
              <div>
                <h3 className="font-serif text-2xl mb-1">{plan.frequency}</h3>
                <p className={`text-sm leading-relaxed ${plan.highlight ? "text-white/80" : "text-[#6A6A6A]"}`}>
                  {plan.description}
                </p>
              </div>
              <ul className="flex flex-col gap-3 my-2">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-2.5 text-sm">
                    <span className={`w-4 h-4 flex items-center justify-center mt-0.5 flex-shrink-0 ${plan.highlight ? "text-white" : "text-[#C41E3A]"}`}>
                      <i className="ri-check-line" />
                    </span>
                    <span className={plan.highlight ? "text-white/90" : "text-[#4A4A4A]"}>{feature}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/contact"
            className="inline-flex items-center gap-2 px-8 py-4 rounded-full bg-[#C41E3A] text-white text-sm font-semibold tracking-wide whitespace-nowrap hover:bg-[#A0182E] transition-colors cursor-pointer"
          >
            Get a Custom Quote
            <span className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line" /></span>
          </Link>
        </div>
      </div>
    </section>
  );
}
